var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5625 0H8.43751C3.79688 0 0 3.79688 0 8.4375V81.5625C0 86.2031 3.79688 90 8.43751 90H81.5625C86.2031 90 90 86.2031 90 81.5625V8.4375C90 3.79688 86.2031 0 81.5625 0ZM33.7488 73.1249H22.5009V33.7489H33.7488V73.1249ZM28.1232 28.1232C25.014 28.1232 22.4992 25.6085 22.4992 22.4992C22.4992 19.3883 25.0139 16.8736 28.1232 16.8736C31.2341 16.8736 33.7488 19.3883 33.7488 22.4992C33.7488 25.6084 31.2341 28.1232 28.1232 28.1232ZM73.125 73.1249H61.8769V50.6257C61.8769 47.5148 59.3607 45.0001 56.2514 45.0001C53.1404 45.0001 50.6258 47.5148 50.6258 50.6257V73.1249H39.3744V33.7489H50.6258V40.7298C52.9427 37.5441 56.4972 33.7489 60.4686 33.7489C67.4661 33.7489 73.1248 40.0438 73.1248 47.8121L73.125 73.1249Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector (6).962db0e74b0df637d616869ba228c4f8.svg";
export { ForwardRef as ReactComponent };